import * as yup from "yup"
import validationMessages from "@utils/validation/messages";

const required = () => {
    return yup.string()
        .required(validationMessages.required)
}

export default required